import React, { Component } from 'react'
import { withRouteData } from 'react-static'

class RedirectToUrl extends Component {
    componentDidMount() {
        window.location.replace(this.props.redirectUrl)
    }

    render() {
        return (
            ''
        )
    }
}

export default withRouteData(({ url }) => (
    <RedirectToUrl redirectUrl={url} />
))



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/RedirectToUrl.jsx